import { render, staticRenderFns } from "./ad-budget.vue?vue&type=template&id=37f49f8b"
import script from "./ad-budget.vue?vue&type=script&lang=js"
export * from "./ad-budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports